import React from "react";

export const AlertBox = ({
  type = "info",
  title,
  children,
  message,
  className = "",
}) => {
  const alertStyles = {
    info: "bg-brand-cream border-brand-charcoal/20 text-brand-charcoal",
    success: "bg-brand-cream border-brand-charcoal/20 text-brand-charcoal",
    warning: "bg-brand-cream border-brand-charcoal/20 text-brand-muted",
    error: "bg-red-50 border-red-200 text-red-800",
  };

  const iconColors = {
    info: "bg-brand-charcoal",
    success: "bg-brand-charcoal",
    warning: "bg-brand-muted",
    error: "bg-red-500",
  };

  return (
    <div className={`border rounded-lg p-4 ${alertStyles[type]} ${className}`}>
      <div className="flex items-center mb-2">
        <div
          className={`w-5 h-5 ${iconColors[type]} rounded-lg flex items-center justify-center mr-2`}
        >
          <span className="text-white text-xs font-bold">!</span>
        </div>
        <h5 className="font-semibold">{title}</h5>
      </div>
      {message && <div>{message}</div>}
      {children}
    </div>
  );
};
